import Highway from "@dogstudio/highway";
import gsap from "gsap";
import AppHandler from "./AppHandler";
import { App } from ".";

export default class Overpass extends Highway.Transition {
  constructor(properties){
    super(properties);
    this.transWrapDuration = .45;
    this.transWrapEasing = "power3.out";
    this.gs = gsap.timeline({ });
    this.transWrap = document.querySelector("#transition__Wrapper");
    this.cpI_Open = "inset(0px 0px 0px 0px)";
    this.cpI_Top = "inset(0px 0px 100% 0px)";
    this.cpI_Bottom = "inset(100% 0px 0px 0px)";
  }

  in({ from, to, done }) { // IN TRANSITION
    this.gs
      .add(function(){
        App.splashInit();
      })
      .fromTo(to, { autoAlpha: 0, yPercent: 10 }, { autoAlpha: 1, yPercent:0, duration: this.transWrapDuration*2, onComplete:
        function(){
          
          from.remove();
          done();
        }})
      .fromTo( Array.from(to.children), {opacity:0, yPercent: 7}, {opacity:1, yPercent: 0, stagger: 0.2} );
  }

  out( {to, from, done} ) { // OUT TRANSITION
    window.scrollTo(0, 0); 
    this.gs.fromTo(from, 
      {autoAlpha: 1, yPercent: 0}, 
      {autoAlpha: 0, yPercent: -7, 
        onComplete: function(){ done(); }}
    );
    App.splashLoad();
  }

}